export function normalizarNiveis(levels: string[]): string[] {
  return (levels ?? [])
    .map((l) => (l ?? '').trim().toUpperCase())
    .filter((l) => l.length > 0);
}

export function validarNiveis(levels: string[]): string | null {
  const bruto = (levels ?? []).map((l) => (l ?? '').trim().toUpperCase());
  if (bruto.some((l) => l.length === 0)) return 'Preencha ou remova as linhas vazias.';

  const repetido = bruto.find((l, i) => bruto.indexOf(l) !== i);
  return repetido ? `Operador repetido: ${repetido}` : null;
}

export function moverNivel(levels: string[], from: number, to: number): string[] {
  const copia = [...(levels ?? [])];
  if (from < 0 || from >= copia.length || to < 0 || to >= copia.length) return copia;

  const [item] = copia.splice(from, 1);
  copia.splice(to, 0, item);
  return copia;
}
